import Modal from "react-modal";
import { updateGroupData } from "../../../services/emailGroupServices";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Mail } from "lucide-react";

export default function EditEmailModal({
  close,
  group,
  selectedUser,
  isAdd = false,
  onSuccess,
  isOpen,
}) {
  const [name, setName] = useState(selectedUser?.name || "");
  const [email, setEmail] = useState(selectedUser?.email || "");

  useEffect(() => {
    if (!isAdd && selectedUser) {
      setName(selectedUser.name || "");
      setEmail(selectedUser.email || "");
    } else {
      setName("");
      setEmail("");
    }
  }, [selectedUser, isAdd]);

  const handleSaveChanges = () => {
    if (!name.trim() || !email.trim()) {
      toast.error("Name and email are required");
      return;
    }

    const payload = {
      name: name.trim(),
      email: email.trim(),
      _id: selectedUser?._id,
    };

    toast
      .promise(updateGroupData(group?._id ?? "", payload), {
        loading: "Saving changes...",
        success: "User updated successfully",
        error: (err) => err.message || "Failed to update user",
      })
      .then(() => {
        onSuccess();
        close();
      });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={close}
      ariaHideApp={false}
      shouldCloseOnOverlayClick={true}
      overlayClassName="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
      className="bg-white animate-scale-in w-full max-w-[450px] rounded-[20px] p-6 relative shadow-lg outline-none animate-scale-in"
    >
      <h2 className="text-center font-semibold text-black mb-3 text-lg">
        {isAdd ? "Add User" : "Edit User"}
      </h2>

      <button
        onClick={close}
        aria-label="Close"
        className="absolute right-5 top-3 text-black text-base font-bold focus:outline-none"
      >
        ✕
      </button>

      <div className="border border-[#E0E0E0] rounded-[10px] p-4">
        <label className="block text-black text-sm font-medium mb-3">
          {isAdd ? "Enter User Details" : "Edit User Details"}
        </label>

        <div className="space-y-3 mb-4">
          <input
            type="text"
            placeholder="Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-3 py-3 border border-gray-300 placeholder:text-black rounded-lg text-sm bg-[#FAFAFA] focus:outline-none focus:ring-1 focus:ring-blue-500"
          />

          <div className="relative">
            <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none text-gray-500">
              <Mail className="w-5 h-5" />
            </div>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full pl-12 pr-3 py-3 border border-gray-300 placeholder:text-black rounded-lg text-sm bg-[#FAFAFA] focus:outline-none focus:ring-1 focus:ring-blue-500"
            />
          </div>
        </div>

        <button
          onClick={handleSaveChanges}
          className="w-full bg-[#4362C1] text-white py-3 rounded-lg text-sm font-semibold cursor-pointer mt-4"
        >
          Save Changes
        </button>
      </div>
    </Modal>
  );
}
